/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Restore_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Restore selected commit" |
*
* @param {Snapshot_History_Restore_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_restore_aria_label = /** @type {((inputs?: Snapshot_History_Restore_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Restore_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Restore selected commit")
	if (locale === "de") return /** @type {LocalizedString} */ ("Restore selected commit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Restore selected commit")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Restore selected commit")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restore selected commit")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Restore selected commit")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Restore selected commit")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Restore selected commit")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Restore selected commit")
	return /** @type {LocalizedString} */ ("Restore selected commit")
});